var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2.5 0v24h18.783V6.57l-.147-.162L14.875.147 14.712 0H2.5Zm1.043 1.043h10.435v6.261h6.261v15.653H3.543V1.043Zm11.479.75 4.467 4.468h-4.467V1.793Zm-8.348 8.642v1.043h10.435v-1.043H6.674Zm0 3.13v1.044h8.348v-1.044H6.674Zm0 3.13v1.044h10.435v-1.043H6.674Z"
  })));
};
export { SvgFile as ReactComponent };